import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Ecosystem } from '../components/Ecosystem';
import { WhyBlinkblis } from '../components/WhyBlinkblis';
import { FeaturedDecisions } from '../components/FeaturedDecisions';
import { Spotlights } from '../components/Spotlights';
import { YouTubeSection } from '../components/YouTubeSection';
import { Newsletter } from '../components/Newsletter';
import { Footer } from '../components/Footer';
import { useScreenInit } from '../useScreenInit';
export function Home() {
  useScreenInit();
  return <div className="min-h-screen bg-background text-white relative selection:bg-accent/30 selection:text-white" data-id="element-348">
      {/* Global Grain Overlay */}
      <div className="grain-overlay" data-id="element-349" />

      <Navbar data-id="element-350" />

      <main data-id="element-351">
        <Hero data-id="element-352" />
        <Ecosystem data-id="element-353" />
        <WhyBlinkblis data-id="element-354" />
        <FeaturedDecisions data-id="element-355" />
        <Spotlights data-id="element-356" />
        <YouTubeSection data-id="element-357" />
        <Newsletter data-id="element-358" />
      </main>

      <Footer data-id="element-359" />
    </div>;
}